import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TempleTimingsTable() {
  const [data, setData] = useState([]);

  const [editingHeadingId, setEditingHeadingId] = useState(null);
  const [headingValue, setHeadingValue] = useState("");

  const [editingTimingId, setEditingTimingId] = useState(null);
  const [timeValue, setTimeValue] = useState("");

  /* ---------------- LOAD DATA ---------------- */

  const loadData = async () => {
    const res = await axios.get(
      "https://spst.in/myapp/api/fetch_timings.php"
    );
    setData(res.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  /* ---------------- STATUS UPDATE ---------------- */

  const updateStatus = async (id, status) => {
    await axios.post(
      "https://spst.in/myapp/api/toggle_status.php",
      { id, status }
    );
    loadData();
  };

  /* ---------------- HEADING ---------------- */

  const updateHeading = async (id) => {
    await axios.post(
      "https://spst.in/myapp/api/update_heading.php",
      { id, heading: headingValue }
    );
    setEditingHeadingId(null);
    loadData();
  };

  const deleteHeading = async (id) => {
    if (!window.confirm("Delete this heading?")) return;
    await axios.post(
      "https://spst.in/myapp/api/delete_heading.php",
      { id }
    );
    loadData();
  };

  /* ---------------- TIMING ---------------- */

  const updateTiming = async (id) => {
    await axios.post(
      "https://spst.in/myapp/api/update_timing.php",
      { id, time_value: timeValue }
    );
    setEditingTimingId(null);
    loadData();
  };

  return (
    <div style={{height:'100vh',overflow:'auto'}}>
    <table className="table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Timings</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {data.map((row) => {
          const status = Number(row.status); // 🔥 IMPORTANT
          const isDisabled = status === 0;

          return (
            <tr
              key={row.id}
              style={{
                backgroundColor: isDisabled ? "#f8d7da" : "#ffffff",
                color: isDisabled ? "#721c24" : "#000"
              }}
            >
              {/* ---------------- HEADING ---------------- */}
              <td>
                {editingHeadingId === row.id ? (
                  <>
                    <input
                      value={headingValue}
                      onChange={(e) => setHeadingValue(e.target.value)}
                    />
                    <button onClick={() => updateHeading(row.id)}>✔</button>
                    <button onClick={() => setEditingHeadingId(null)}>✖</button>
                  </>
                ) : (
                  <>
                    <strong>{row.heading}</strong>
                    <button
                      style={{ marginLeft: 6 }}
                      onClick={() => {
                        setEditingHeadingId(row.id);
                        setHeadingValue(row.heading);
                      }}
                    >
                      ✏
                    </button>
                  </>
                )}
              </td>

              {/* ---------------- TIMINGS ---------------- */}
              <td>
                <b>🌅 Morning</b>
                {row.morning.map((m) => (
                  <div key={m.id}>
                    {editingTimingId === m.id ? (
                      <>
                        <input
                          value={timeValue}
                          onChange={(e) => setTimeValue(e.target.value)}
                        />
                        <button onClick={() => updateTiming(m.id)}>✔</button>
                        <button onClick={() => setEditingTimingId(null)}>✖</button>
                      </>
                    ) : (
                      <>
                        {m.time_value}
                        <button
                          style={{ marginLeft: 6 }}
                          onClick={() => {
                            setEditingTimingId(m.id);
                            setTimeValue(m.time_value);
                          }}
                        >
                          ✏
                        </button>
                      </>
                    )}
                  </div>
                ))}

                <b>🌇 Evening</b>
                {row.evening.map((e) => (
                  <div key={e.id}>
                    {editingTimingId === e.id ? (
                      <>
                        <input
                          value={timeValue}
                          onChange={(ev) => setTimeValue(ev.target.value)}
                        />
                        <button onClick={() => updateTiming(e.id)}>✔</button>
                        <button onClick={() => setEditingTimingId(null)}>✖</button>
                      </>
                    ) : (
                      <>
                        {e.time_value}
                        <button
                          style={{ marginLeft: 6 }}
                          onClick={() => {
                            setEditingTimingId(e.id);
                            setTimeValue(e.time_value);
                          }}
                        >
                          ✏
                        </button>
                      </>
                    )}
                  </div>
                ))}
              </td>

              {/* ---------------- STATUS ---------------- */}
              <td>
                <strong>
                  {status === 1 ? "Enabled" : "Disabled"}
                </strong>

                <br />

                <button
                  style={{
                    marginTop: 6,
                    marginRight: 6,
                    background: "#28a745",
                    color: "#fff",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                    opacity: status === 1 ? 0.5 : 1
                  }}
                  disabled={status === 1}
                  onClick={() => updateStatus(row.id, 1)}
                >
                  Enable
                </button>

                <button
                  style={{
                    marginTop: 6,
                    background: "#dc3545",
                    color: "#fff",
                    border: "none",
                    padding: "5px 10px",
                    cursor: "pointer",
                    opacity: status === 0 ? 0.5 : 1
                  }}
                  disabled={status === 0}
                  onClick={() => updateStatus(row.id, 0)}
                >
                  Disable
                </button>
              </td>

              {/* ---------------- ACTIONS ---------------- */}
              <td>
                <button onClick={() => deleteHeading(row.id)}>
                  🗑 Delete
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
}
